import React from 'react';

const ScanLines: React.FC = () => {
  return (
    <div className="fixed inset-0 pointer-events-none z-10">
      <div className="scan-line animate-scan-lines"></div>
      <div className="scan-line animate-scan-lines" style={{ animationDelay: '2s' }}></div>
      <div className="scan-line animate-scan-lines" style={{ animationDelay: '4s' }}></div>
      <div className="scan-line animate-scan-lines" style={{ animationDelay: '6s' }}></div>
      <div className="scan-line animate-scan-lines" style={{ animationDelay: '8s' }}></div>
    </div>
  );
};

export default ScanLines;
